import { GetInvalidReason } from './types';

const getEmptyReason: GetInvalidReason = (source: string) => {
  return source ? undefined : 'is-empty';
};

export default getEmptyReason;
